module.exports = __webpack_public_path__ + "img/dhbw.3e0926d0.png";